import React, { Component } from 'react';
import { connect } from "react-redux";
import { ListGroupItem } from 'reactstrap';
import MaterialIcon from "material-icons-react";
import i18n from "../i18next";

import {
    clearOrdersHistory,
    deleteNotification,
    loadNotifications,
    loadOrdersHistory,
    loadJobDetails,
    getOrdersDetails
} from "../actions/index";
import {
    PRODUCT_REPORT,
    DOWNLOAD_ORDERS_REPORT,
    CENTRAL_SEARCH_ORDER_REPORT,
    FRONT_END_URL,
    WIPE_MENU
} from '../utils/Constants';

class NotificationListItem extends Component {
    constructor(props) {
        super(props);

        this.deleteNotification = this.deleteNotification.bind(this);
        this.loadOrderDetails = this.loadOrderDetails.bind(this);
    }

    renderStatusIcon(notificationType) {

        if (notificationType == 'IMPORT_COMPLETED' || notificationType == 'PUBLISH_COMPLETED' || notificationType === WIPE_MENU
            || notificationType === PRODUCT_REPORT || notificationType === DOWNLOAD_ORDERS_REPORT || notificationType === CENTRAL_SEARCH_ORDER_REPORT) {
            return (
                <span style={{ padding: 2 }}>
                    <MaterialIcon icon="lens" color="#7e9f00" size={8} />
                </span>
            )
        } else {
            return (
                <span style={{ padding: 2 }}>
                    <MaterialIcon icon="lens" color="#bf212a" size={8} />
                </span>
            )
        }
    }

    renderDeleteIcon(notificationId) {
        const { deleteNotification } = styles;

        return (
            <span style={deleteNotification} onClick={() => this.deleteNotification(notificationId)}>
                <MaterialIcon icon="close" color="#495058" size={16} />
            </span>
        )
    }

    deleteNotification(notificationId) {
        this.props.deleteNotification(notificationId);
    }

    loadOrderDetails(orderId, restaurantId, state) {
        this.props.getOrdersDetails(orderId, () => {
            this.props.toggle();
        }, restaurantId, true, state);
    }

    loadJobState(jobId) {
        this.props.loadJobDetails(jobId);
        this.props.toggle();
    }

    renderSeeMoreLink() {
        const { dateStyle, orderDetailsLink } = styles;
        const { isOrderDetails, notification } = this.props;

        let state = {
            "data": null,
            "jobDetailsScreenOpened": true
        };


        if (isOrderDetails) {
            state = {
                "data": JSON.parse(notification.data),
                "orderDetailsScreenOpened": true
            }

            if (state.data.orderId == undefined || state.data.orderId == null) {
                state = {
                    "data":
                        // {
                        //     jobId: 630664
                        // },
                        JSON.parse(notification.data),
                    "jobDetailsScreenOpened": true
                }
            }
        } else {
            state = {
                "data": JSON.parse(notification.data),
                "jobDetailsScreenOpened": true
            }
        }

        if (state.data !== undefined && state.data !== null) {
            if (state.data.orderId !== undefined && state.data.orderId !== null) {
                return (
                    <p style={dateStyle}>{notification.date}
                        <span onClick={() => this.loadOrderDetails(state.data.orderId, state.data.restaurantId, state)} style={orderDetailsLink}>
                            {i18n.t('screens:mainContainer.seeMore')}
                        </span>
                    </p>
                )
            } else if (state.data.jobId !== undefined && state.data.jobId !== null && notification.type !== WIPE_MENU) {
                return (
                    <p style={dateStyle}>{notification.date}
                        <span onClick={() => this.loadJobState(state.data.jobId)} style={orderDetailsLink}>
                            {i18n.t('screens:mainContainer.seeMore')}
                        </span>
                    </p>
                );
            } else if (notification.type === PRODUCT_REPORT || notification.type === DOWNLOAD_ORDERS_REPORT || notification.type === CENTRAL_SEARCH_ORDER_REPORT) {
                return (
                    <p style={dateStyle}>{notification.date}
                        <a
                            href={`${FRONT_END_URL}${state.data.source}`}
                            download
                            style={orderDetailsLink}>{i18n.t('screens:mainContainer.downloadReport')}
                        </a>
                    </p>
                );
            }
        } else {
            return (
                <p style={dateStyle}>{notification.date}</p>
            );
        }
    }


    render() {
        const { notificationListGroupItem, notificationType, restaurantName } = styles;
        const { isNotificationHidden, notification, key } = this.props;
        const stringifiedData = notification.data ? JSON.parse(notification.data) : '';

        return (
            <ListGroupItem hidden={isNotificationHidden} value={notification.type} id={notification.id} key={key} style={notificationListGroupItem}>
                <p style={notificationType}>
                    {i18n.t(`screens:mainContainer.${notification.type}`)}{stringifiedData.rejectReason ? ` (${i18n.t(`screens:mainContainer.${stringifiedData.rejectReason}`)})` : null}
                    {this.renderStatusIcon(notification.type)}
                    {this.renderDeleteIcon(notification.id)}
                </p>
                <p style={restaurantName}>{notification.restaurantName}</p>
                {this.renderSeeMoreLink()}
            </ListGroupItem>
        );
    }
}

const mapStateToProps = state => {
    return {
        notifications: state.notifications
    };
};

export default connect(mapStateToProps, {
    loadNotifications,
    deleteNotification,
    clearOrdersHistory,
    loadOrdersHistory,
    loadJobDetails,
    getOrdersDetails
})(NotificationListItem);

const styles = {
    notificationListGroup: {
        maxHeight: 420,
        overflowY: 'auto'
    },
    notificationType: {
        marginBottom: 5,
        marginRight: 2
    },
    notificationListGroupItem: {
        padding: '5px 0px 0px 12px'
    },
    restaurantName: {
        fontSize: 12,
        color: 'grey',
        marginRight: 50,
        marginBottom: 2
    },
    dateStyle: {
        fontSize: 12,
        color: 'grey',
        marginRight: 2,
        marginBottom: 2
    },
    deleteNotification: {
        cursor: 'pointer',
        float: 'right',
        marginRight: 10
    },
    orderDetailsLink: {
        cursor: 'pointer',
        color: '#0288d1',
        float: 'right',
        fontSize: 14,
        marginTop: -10
    }
}


// WEBPACK FOOTER //
// ./src/components/NotificationListItem.js